export default __webpack_public_path__ + "static/media/ausdp.412676b8.svg";